import { gql } from '@apollo/client';
import { GqlOrganization, GqlOrganizationFragment, GqlBasicOrganizationFragment } from '../fragments/organization';

export interface Variables {
  organizationId: string;
}

export interface Data {
  showOrganization: GqlOrganization;
}

export const BASIC_ORG_QUERY = gql`
  query ShowOrganization($organizationId: Int!) {
    showOrganization(organizationId: $organizationId) {
      ...BasicOrganizationFields
    }
  }
  ${GqlBasicOrganizationFragment}
`;

export const ORG_QUERY_FOR_SEASONS_PAGE = gql`
  query ShowOrganization($organizationId: Int!) {
    showOrganization(organizationId: $organizationId) {
      id
      name
      country
      zipCode
      timezone
      registrationType
      roles {
        organizationId
        userId
        personId
        type
        isTsSupportAdmin
      }
    }
  }
`;

export const QUERY = gql`
  query ShowOrganization($organizationId: Int!) {
    showOrganization(organizationId: $organizationId) {
      ...OrganizationFields
    }
  }
  ${GqlOrganizationFragment}
`;

export const ADMINS_QUERY = gql`
  query ShowOrganization($organizationId: Int!) {
    showOrganization(organizationId: $organizationId) {
      ...OrganizationFields
      legacyOrg {
        id
        name
      }
      hasLegacySeasonConnected
      additionalLegacyOrgs {
        id
        name
      }
      disabled
      disabledMessageType
      disabledMessageTemplate
      isTest
      isTrial
      tournamentOrg {
        id
        name
      }
      activityLogs {
        id
        organizationId
        description
        transactedAt
      }
      websiteUrl
    }
  }
  ${GqlOrganizationFragment}
`;
